import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { SessionListItem } from '../SessionListItem';
import { ClipListItem } from '../ClipListItem';
import { Box, Button, Divider } from '@fullstory/components';
import { take } from 'lodash';

interface Id {
  id: string;
}
export interface SessionList {
  clips: (Omit<React.ComponentProps<typeof ClipListItem>, 'onPlayClick'> & Id)[];
  sessions: (Omit<React.ComponentProps<typeof SessionListItem>, 'onPlayClick'> & Id)[];
  onPlayClick: () => void;
}

const PaddedDivider: React.FC = () => (
  <Box data-component="PaddedDivider" paddingTop={12} style={{ position: 'relative' }}>
    <Divider />
  </Box>
);
const ITEM_LIMIT = 5;
export const SessionList: React.FC<SessionList> = ({ sessions, clips, onPlayClick }) => {
  const [showMore, setShowMore] = useState(false);
  return (
    <Box
      data-component="SessionList"
      paddingTop={12}
      paddingBottom={12}
      paddingLeft={24}
      paddingRight={24}
    >
      {take(clips, !showMore ? ITEM_LIMIT : clips.length ?? 0).map((clip, i) => (
        <React.Fragment key={clip.id}>
          <ClipListItem {...clip} onPlayClick={onPlayClick} />
          {i < clips.length - 1 && <PaddedDivider />}
        </React.Fragment>
      ))}
      {take(sessions, !showMore ? ITEM_LIMIT : sessions.length ?? 0).map((session, i) => (
        <React.Fragment key={session.id}>
          <SessionListItem {...session} onPlayClick={onPlayClick} />
          {i < sessions.length - 1 && <PaddedDivider />}
        </React.Fragment>
      ))}
      {!showMore && (clips.length > ITEM_LIMIT || sessions.length > ITEM_LIMIT) && (
        <Box paddingTop={12} paddingBottom={12}>
          <Button
            variant="minimal"
            onClick={e => {
              e.preventDefault();
              setShowMore(true);
            }}
          >
            <FormattedMessage defaultMessage="Show more..." id="uDmRJo" />
          </Button>
        </Box>
      )}
    </Box>
  );
};
